import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

const INFO_NAV = [
  { label: "Naudinga info", to: "/info" },
  { label: "Pristatymas", to: "/pristatymas" },
  { label: "D.U.K.", to: "/duk" },
  { label: "Apie", to: "/mus" },
];

export default function BottomBar() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const nearBottom = window.innerHeight + y >= document.body.offsetHeight - 130;
      setShow(y > 150 && !nearBottom);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`hidden md:block fixed bottom-4 left-1/2 -translate-x-1/2 z-40 transition-all duration-300 ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8 pointer-events-none"}`}
      data-testid="floating-bottom-bar"
    >
      <div className="bg-white dark:bg-[#111A28]/95 backdrop-blur border border-gray-200 dark:border-gray-700 shadow-[0_8px_30px_rgba(0,0,0,0.15)] rounded-full pl-2 pr-2 py-1.5 flex items-center gap-1 max-w-[94vw] overflow-x-auto">
        <span className="hidden sm:inline font-mono text-[10px] uppercase tracking-widest text-gray-400 px-3 shrink-0">// 3D filamentai · LT</span>
        {INFO_NAV.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            className={({ isActive }) => `text-xs px-3 py-1.5 rounded-full whitespace-nowrap transition-colors ${isActive ? "bg-[#00B5E2] text-white" : "text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"}`}
          >
            {n.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
